import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon, LocalHospital as HospitalIcon, Message as MessageIcon } from '@mui/icons-material';
import SearchBar from '../SearchBar';
import { styles } from '../../styles/ChemoRecordsStyles';
import { chemoTranslations } from '../../hooks/chemo/chemoTranslations';

const ChemoRecordsHeader = ({ searchTerm, onSearchChange, canCreate, onNewReport, onOpenMessage }) => {
    return (
        <Box sx={styles.headerContainer}>
            <Box sx={styles.headerContentWrapper}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: '12px', md: '16px' },
                    flex: { xs: '1 1 100%', sm: 'initial' }
                }}>
                    <Box sx={styles.headerIconBox}>
                        <HospitalIcon sx={{
                            fontSize: { xs: 24, sm: 28, md: 32 },
                            color: '#fff'
                        }} />
                    </Box>
                    <Box>
                        <Typography
                            variant="h4"
                            sx={styles.headerTitle}
                        >
                            {chemoTranslations.labels.chemoReports}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={styles.headerSubtitle}
                        >
                            {chemoTranslations.labels.chemoManagement}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, flexDirection: { xs: 'column', sm: 'row' } }}>
                    <Button
                        variant="outlined"
                        onClick={onOpenMessage}
                        sx={{
                            borderColor: '#3498db',
                            color: '#3498db',
                            fontSize: { xs: '13px', sm: '14px', md: '15px' },
                            padding: { xs: '10px 20px', sm: '11px 26px', md: '12px 30px' },
                            fontWeight: 600,
                            borderRadius: { xs: '8px', md: '10px' },
                            textTransform: 'none',
                            letterSpacing: '0.3px',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                borderColor: '#2980b9',
                                backgroundColor: 'rgba(52, 152, 219, 0.04)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                        startIcon={<MessageIcon />}
                    >
                        {chemoTranslations.table.messageToService}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onNewReport}
                        sx={styles.newReportButton}
                        startIcon={<AddIcon />}
                    >
                        {chemoTranslations.labels.newReport}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default ChemoRecordsHeader;